"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var foldline_1 = __importDefault(require("foldline"));
var property_1 = require("./property");
var VCard = /** @class */ (function () {
    /**
     * A class describing a single vCard object.
     * Accepts a `string` or `Buffer` with the contents of a `.vcf` file,
     * or a JSON `object` in {@link JCard} format.
     *
     * @example
     * ```javascript
     * new VCard(fs.readFileSync('card.vcf'));
     * ```
     * @example
     * ```javascript
     * new VCard('...vcf string...');
     * ```
     * @example
     * ```javascript
     * new VCard(require('./jcard.json'));
     * ```
     */
    function VCard(input) {
        this.props = new Map();
        this.version = VCard.versions[VCard.versions.length - 1];
        if (!input)
            return;
        // read from vCard
        else if (typeof input === 'string' || input instanceof Buffer) {
            this.parseFromVcf(input);
        }
        // read from jCard
        else if (typeof input === 'object') {
            this.parseFromJCard(input);
        }
        else
            throw new Error('error reading vcard');
    }
    VCard.prototype.parseFromVcf = function (vcf) {
        var _this = this;
        var lines = exports.normalizeCard(vcf).split(/\r\n/g);
        // keep for error messages
        var begin = lines[0];
        var version = lines[1];
        var end = lines[lines.length - 1];
        if (!/BEGIN:VCARD/i.test(begin))
            throw new SyntaxError("Invalid vCard: Expected \"BEGIN:VCARD\" but found \"" + begin + "\"");
        if (!/END:VCARD/i.test(end))
            throw new SyntaxError("Invalid vCard: Expected \"END:VCARD\" but found \"" + end + "\"");
        // TODO: For version 2.1, the VERSION can be anywhere between BEGIN & END
        if (!/VERSION:\d\.\d/i.test(version))
            throw new SyntaxError("Invalid vCard: Expected \"VERSION:\\d.\\d\" but found \"" + version + "\"");
        this.version = version.substring(8, 11);
        if (!VCard.isSupported(this.version))
            throw new Error("Unsupported version \"" + this.version + "\"");
        lines.forEach(function (line) {
            try {
                var p = new property_1.Property(line);
                var ignoreProps = ['begin', 'end'];
                if (!ignoreProps.includes(p.getField()))
                    _this.add(new property_1.Property(line));
            }
            catch (err) {
                console.warn(err.message);
            }
        });
    };
    VCard.prototype.parseFromJCard = function (_json) {
        var _this = this;
        var json = JSON.parse(JSON.stringify(_json));
        if (!/vcard/i.test(json[0]))
            throw new SyntaxError('Incorrect jCard format');
        json[1].forEach(function (jprop) { return _this.add(new property_1.Property(jprop)); });
    };
    /**
     * Retrieve an array of {@link Property} objects under the specified field.
     * Returns [] if there are no Property objects found.
     * Properites are always stored in an array.
     * @param field to get.
     * @param type If provided, only return {@link Property}s with the specified
     * type as a param.
     */
    VCard.prototype.get = function (field, type) {
        if (type) {
            var props = this.props.get(field);
            if (!props)
                return [];
            return props.filter(function (prop) {
                var types = prop.params['type'];
                if (!types)
                    return false;
                return Array.isArray(types) ? types.includes(type) : types === type;
            });
        }
        return this.props.get(field) || [];
        // TODO with type filter-er
    };
    /**
     * Retrieve a _single_ Property of the specified field. Attempts to pick based
     * on the following priorities, in order:
     * - `TYPE={type}` of the value specified in the `type` argument. Ignored
     * if the argument isn't supplied.
     * - `TYPE=pref` is present.
     * - is the Property at index 0 from get(field)
     * @param field
     * @param type
     */
    VCard.prototype.getOne = function (field, type) {
        return this.get(field, type || 'pref')[0] || this.get(field)[0];
    };
    /**
     * Set the contents of a field to contain a single {@link Property}.
     *
     * Accepts either 2-4 arguments to construct a Property,
     * or 1 argument of a preexisting Property object.
     *
     * This will always overwrite all existing properties of the given
     * field. For just adding a new property, see {@link VCard#add}
     * @param arg the field, or a Property object
     * @param value the value for the Property object
     * @param params the parameters for the Property object
     * @param group the group for the Property object
     */
    VCard.prototype.set = function (arg, value, params, group) {
        if (typeof arg === 'string') {
            var field = String(arg);
            var newProp = new property_1.Property(field, value, params, group);
            this.props.set(field, [newProp]);
            return newProp;
        }
        else if (arg instanceof property_1.Property) {
            var field = arg.getField();
            this.props.set(field, [arg]);
            return arg;
        }
        else
            throw new Error('invalid argument of VCard.set(), expects ' +
                'string arguments or a Property');
    };
    /**
     * Adds a {@link Property} without modifying other properties.
     *
     * Accepts either 2.4 arguments to construct a {@link Property},
     * or 1 argument of a preexisting {@link Property} object.
     *
     * @param arg the field, or a {@link Property} object
     * @param value the value for the Property object
     * @param params the parameters for the Property object
     * @param group the group for the Property object
     */
    VCard.prototype.add = function (arg, value, params, group) {
        var _a, _b;
        // string arguments
        if (typeof arg === 'string') {
            var field = String(arg);
            var newProp = new property_1.Property(field, value, params, group);
            if (this.props.get(field))
                (_a = this.props.get(field)) === null || _a === void 0 ? void 0 : _a.push(newProp);
            else
                this.props.set(field, [newProp]);
            return newProp;
        }
        // Property arguments
        else if (arg instanceof property_1.Property) {
            var field = arg.getField();
            if (this.props.get(field))
                (_b = this.props.get(field)) === null || _b === void 0 ? void 0 : _b.push(arg);
            else
                this.props.set(field, [arg]);
            return arg;
        }
        // incorrect arguments
        else
            throw new Error('invalid argument of VCard.add(), expects ' +
                'string arguments or a Property');
    };
    /**
     * Removes a {@link Property}, or all properties of the supplied field.
     * @param arg the field, or a {@link Property} object
     * @param paramFilter (incomplete)
     */
    VCard.prototype.remove = function (arg, paramFilter) {
        var _a;
        // string arguments
        if (typeof arg === 'string') {
            //TODO filter by param
            this.props.delete(arg);
        }
        // Property argument
        else if (arg instanceof property_1.Property) {
            var propArray = this.props.get(arg.getField());
            if (!((_a = propArray) === null || _a === void 0 ? void 0 : _a.includes(arg)))
                throw new Error("Attempted to remove property VCard does not have: " + arg);
            propArray.splice(propArray.indexOf(arg), 1);
            if (propArray.length === 0)
                this.props.delete(arg.getField());
        }
        // incorrect arguments
        else
            throw new Error('invalid argument of VCard.remove(), expects ' +
                'string and optional param filter or a Property');
    };
    /**
     * Returns true if the vCard has at least one @{link Property}
     * of the given field.
     * @param field The field to query
     */
    VCard.prototype.has = function (field) {
        return (!!this.props.get(field) &&
            this.props.get(field).length > 0);
    };
    /**
     * returns a `.vcf` formatted string with CRLF endings.
     * @param version (incomplete)
     */
    VCard.prototype.toString = function (version) {
        var v = version || this.version;
        return exports.formatCard(this, v);
    };
    /**
     * Returns a {@link JCard} object as a JSON array.
     */
    VCard.prototype.toJCard = function () {
        var e_1, _a, e_2, _b;
        var data = [['version', {}, 'text', '4.0']];
        try {
            // this.props.forEach((props, field) => {
            // 	if (field === 'version') return
            // 	props.forEach(prop => {
            // 		if (prop.isEmpty()) return
            // 		data.push(prop.toJSON())
            // 	})
            // })
            for (var _c = __values(this.props.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), field = _e[0], props = _e[1];
                if (field === 'version')
                    continue;
                try {
                    for (var props_1 = (e_2 = void 0, __values(props)), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
                        var prop = props_1_1.value;
                        if (prop.isEmpty())
                            continue;
                        data.push(prop.toJSON());
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (props_1_1 && !props_1_1.done && (_b = props_1.return)) _b.call(props_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return ['vcard', data];
    };
    /**
     * Automatically generate the 'fn' property from the preferred 'n' property.
     *
     * #### `set` (`boolean`)
     *
     * - `false`: (default) return the generated full name string without
     * modifying the VCard.
     *
     * - `true`: modify the VCard's `fn` property directly, as specified
     * by `append`
     *
     * #### `append` (`boolean`)
     *
     * (ignored if `set` is `false`)
     *
     * - `false`: (default) replace the existing 'fn' property/properties with
     * a new one.
     *
     * - `true`: append a new `fn` property to the array.
     *
     * see: [RFC 6350 section 6.2.1](https://tools.ietf.org/html/rfc6350#section-6.2.1)
     */
    VCard.prototype.parseFullName = function (options) {
        if (options === void 0) { options = {}; }
        var _a = options.append, append = _a === void 0 ? false : _a, _b = options.set, set = _b === void 0 ? false : _b;
        // Position in n -> position in fn
        var positionMappings = [3, 1, 2, 0, 4];
        var n = this.getOne('n');
        var fnString = '';
        if (n === undefined)
            throw new Error(
            // prettier-ignore
            '\'fn\' property not present in card, cannot parse full name');
        var nSplit = n.getValue().split(';');
        positionMappings.forEach(function (pos, i) {
            var splitStr = nSplit[pos];
            if (!splitStr)
                return;
            // comma separated values separated by spaces
            fnString += ' ' + splitStr.replace(',', ' ');
        });
        fnString = fnString.trim();
        var fn = new property_1.Property('fn', fnString);
        if (set) {
            if (append) {
                this.add(fn);
            }
            else {
                this.set(fn);
            }
        }
        return fn;
    };
    /* ======================================================================== */
    /**
     * Creates an array of vCard objects from a multi-card `.vcf` string.
     * @param input string or Buffer containing 1 or more vCards
     */
    VCard.fromMultiCardString = function (input) {
        var cardStrings = String(input).split(/(?=BEGIN\:VCARD)/gi);
        return cardStrings.map(function (cardString) { return new VCard(cardString); });
    };
    /**
     * Returns true if the version is supported.
     * @param version The version to query
     */
    VCard.isSupported = function (version) {
        return (/^\d\.\d$/.test(version) &&
            VCard.versions.includes(version));
    };
    VCard.mimeType = 'text/vcard';
    VCard.extension = '.vcf';
    VCard.versions = ['2.1', '3.0', '4.0'];
    VCard.eol = '\r\n';
    return VCard;
}());
exports.VCard = VCard;
/** @hidden */
exports.normalizeCard = function (input) {
    return (String(input)
        // Trim whitespace
        .replace(/^[\s\r\n]+|[\s\r\n]+$/g, '')
        // Trim blank lines
        .replace(/(\r\n)[\x09\x20]?(\r\n)|$/g, '$1')
        // Unfold folded lines
        .replace(/\r\n[\x20\x09]/g, ''));
};
/** @hidden */
exports.formatCard = function (card, _version) {
    var version = _version || card.version || VCard.versions[VCard.versions.length - 1];
    if (!VCard.isSupported(version))
        throw new Error("Unsupported vCard version \"" + version + "\"");
    var vcf = ['BEGIN:VCARD', 'VERSION:' + version];
    card.props.forEach(function (props, field) {
        if (field === 'version')
            return;
        props.forEach(function (prop) {
            if (prop.isEmpty())
                return;
            vcf.push(foldline_1.default(prop.toString(version), 75));
        });
    });
    vcf.push('END:VCARD');
    return vcf.join(VCard.eol);
};
